export default "__VITE_ASSET__30ed4aff__"